import request from '@/utils/request'

export function addByRoleId(id, menus) {
  return request({
    url: `/sysRolePermission/addByRoleId/${id}`,
    method: 'post',
    data: menus
  })
}
